import React from "react";
import { connect } from "react-redux";
import { Trans } from "react-i18next";
import { api } from "api";
import i18n from "i18next";
import Select from "react-select";
import { APIURL } from "util/constant";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import requireAuth from "components/hoc/requireAuth";
import "./employee360.css";

class CareerPath extends React.Component {
  state = {
    employeePosition: this.props.generalProfile.positionId,
    positionVideos: null,
    positions: null,
    selectedPosition: null,
    selectedPositionVideo: null,
  };

  componentDidMount() {
    this.getPositionVideos();
  }

  getPositionVideos = () => {
    this.props.onProcessBegin();
    api
      .get(`/api/employee-360/position-videos`)
      .then((response) => {
        this.setState({
          positionVideos: response.data.data.positionVideos,
          positions: response.data.data.positions,
        });
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.props.onProcessEnd();
      });
  };

  handlePositionSelect = (e) => {
    this.setState({ selectedPosition: e.value, selectedPositionVideo: null });
  };

  renderPositionCombo = () => {
    if (this.state.positions === null || this.state.positions.length === 0)
      return null;

    const options = this.state.positions.map((position) => ({
      value: position.id,
      label: position.name,
    }));

    const defaultOption = options.find(
      (option) => option.value === this.state.employeePosition
    );

    return (
      <Select
        placeholder={i18n.t("10521")}
        options={options}
        onChange={(e) => this.handlePositionSelect(e)}
        defaultValue={defaultOption}
        className="positionVideoSelect"
      />
    );
  };

  renderPlayer = (selectedVideo) => {
    if (!selectedVideo) return null;
    const source = `${selectedVideo.link}?color=ffffff&title=0&byline=0&portrait=0`;
    return (
      <iframe
        className="embed-responsive-item"
        src={source}
        allow="autoplay; fullscreen"
        allowFullScreen
        title={selectedVideo.name}
      ></iframe>
    );
  };

  renderPlaylist = (videos, selectedVideo) => {
    if (!videos || videos.length === 0) return null;

    return videos.map((video) => {
      const thumbnailURL = `url('${APIURL}${video.thumbnailPath}')`;
      return (
        <div
          key={video.id}
          onClick={() => this.setState({ selectedPositionVideo: video })}
          className="col-xs-12 col-sm-12 col-md-12 col-lg-12"
        >
          <div
            className={`video-player-link ${
              video.id === selectedVideo.id && "active"
            }`}
          >
            <div className="imageSecVideoBg">
              <div className="sec-video-name">
                <span className="icon-icon-play"></span>
              </div>
              <div
                className="videoThumbImg"
                style={{
                  backgroundImage: thumbnailURL,
                  position: "relative",
                  zIndex: -1,
                }}
              ></div>
            </div>
            <div className="videoAreaTitle mt-2">
              <span>{video.name}</span>
            </div>
          </div>
        </div>
      );
    });
  };

  renderVideos = () => {
    const filterPosition =
      this.state.selectedPosition ?? this.state.employeePosition;
    const filteredPositionVideos = this.state.positionVideos.filter(
      (positionVideo) => {
        return (
          positionVideo.position && positionVideo.position.id === filterPosition
        );
      }
    );

    if (filteredPositionVideos.length === 0)
      return (
        <div className="row">
          <div className="col-12 text-center">
            <Trans>employee360_videonotfound</Trans>
          </div>
        </div>
      );

    const selectedVideo =
      this.state.selectedPositionVideo ?? filteredPositionVideos[0];

    return (
      <div className="row">
        <div className="col-12 video-list-area">
          <div className="video-preview-area px-1">
            <div
              className="embed-responsive embed-responsive-16by9"
              id="video-player"
            >
              {this.renderPlayer(selectedVideo)}
            </div>
          </div>
          <div className="video-thumb-area px-1">
            <div className="videolar-sag">
              {this.renderPlaylist(filteredPositionVideos, selectedVideo)}
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderContent = () => {
    if (
      this.state.employeePosition === null ||
      this.state.positionVideos === null
    )
      return null;

    return (
      <React.Fragment>
        <div className="d-flex align-items-center justify-content-end mb-2">
          <div>
            <label style={{ fontSize: "14px" }}>
              <Trans>employee360_position</Trans>:
            </label>
            <div
              className="ml-2"
              style={{ display: "inline-block", width: "300px" }}
            >
              {this.renderPositionCombo()}
            </div>
          </div>
        </div>
        {this.renderVideos()}
      </React.Fragment>
    );
  };

  render() {
    return (
      <React.Fragment>
        {this.props.spinner}
        {this.renderContent()}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    generalProfile: state.profile.general,
  };
};

export default connect(mapStateToProps)(
  requireAuth(containsLongRunningProcess(CareerPath))
);
